import { useState, useEffect } from "react";
import apiService from "../../Services/apiService";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/General/Loading";
import Captcha from "../General/Captcha";
 

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [usrname, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const [errUsername, setErrUsername] = useState("");
  const [errPass, setErrPass] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const [msg, setMsg] = useState("");

 
  const [captchaVerified, setCaptchaVerified] = useState(false);
  useEffect(() => {
    localStorage.removeItem("user-server");
    console.log(isEnabled);
  },[isEnabled]);
  const handleSubmitLogin = (e: any) => {
      e.preventDefault(); 
    if (!captchaVerified){ setError("لم يتم التحقق البصري");; return;}
    if (validateForm()) {
      checkLogin();
    }  
  };
  const checkLogin = async () => {
    setLoading(true);
    const result = await apiService.fetchData("api/CheckUser", {
      UsrName: usrname,
      EnPass: pass,
    });
    if (result.isOk === true) {
      localStorage.setItem("user-server", result.data.toString());
      localStorage.setItem("user-module", "2");
       
      navigate("/admin/home");
    } else {
      setError(result.errAr);
      localStorage.removeItem("user-server");
       localStorage.removeItem("user-module");
      setLoading(false);
    }
  };
  const validateForm = () => {
    let isValidate = true;
    if (usrname.trim() === "") {
      isValidate = false;
      setErrUsername("إدخل اسم المستخدم**");
    } else {
      setErrUsername("");
    }
    if (pass.trim() === "") {
      isValidate = false;
      setErrPass("إدخل كلمة المرور** ");
    } else {
      setErrPass("");
    }
     
    // if (rechapteCode.trim() === "") {
    //   isValidate = false;
    //   seterrRechapta("إدخل رمز التحقق البصري** ");
    // } else {
    //   seterrRechapta("");
    // }
    return isValidate;
  };

  
  return (
    <>
      <>
        {loading && <Loading />}
        <meta charSet="utf-8" />
        <meta content="width=device-width, initial-scale=1.0" name="viewport" />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "@layer base{html,body{margin:0;padding:0;}body{overscroll-behavior:none;}main>:first-child{margin-top:0!important;}main>:last-child{margin-bottom:0!important;}}::-webkit-scrollbar{display:none;}",
          }}
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Hanken+Grotesk:wght@600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap"
          rel="stylesheet"
        />
        <main className="w-full max-w-md mx-auto p-gutter">
          <div
            className="flex flex-col w-full h-full min-h-[calc(100vh-theme(spacing.filter-bar-height))] bg-surface font-body-md text-on-surface items-center justify-center p-gutter relative overflow-hidden"
            dir="rtl"
          >
            {/* Decorative Ambient Background */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
              <div className="absolute top-[-20%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-primary-fixed/30 blur-[100px] opacity-50 mix-blend-multiply" />
              <div className="absolute bottom-[-20%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-secondary-fixed/20 blur-[120px] opacity-40 mix-blend-multiply" />
            </div>
            {/* Login Card */}
            <div
              className="relative w-full max-w-sm bg-surface-container-lowest rounded-2xl shadow-xl p-8 z-10 flex flex-col gap-6"
              style={{ boxShadow: "0 10px 40px -10px rgba(10, 25, 47, 0.12)" }}
            >
              {/* Header */}
              <div className="flex flex-col items-center gap-2 mb-2">
                <img
                  alt="Manafith Logo"
                  className="h-16 object-contain mb-4"
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuAbYA6BRVJHsiNlnLeWx-W5SmzOofLHZULbs8AvBer5XSxaLMDl3RWjrrrKL2cKwnmU9PRD3Rgapz1dvs1kxtp5NgUA2E1qJOj78A1tt0p7Vl2vHrkHVbQJeOJqGjDUv19Tu6fACQMRnZH57G8YExE1fbxFvQog4k054S45LHgbZyGca-IX7Wd_ECbytwpZdJkzxnLkbACZOztz7xbU7rRH0T7KjLCzqAeZgKIiO6j1510xK_OrKTvhMWSO9mTDNKds3LQ"
                />
                <div className="w-16 h-16 rounded-xl bg-primary flex items-center justify-center text-on-primary shadow-md shadow-primary/20 mb-2">
                  <span
                    className="material-symbols-outlined text-4xl"
                    style={{ fontVariationSettings: '"FILL" 1' }}
                  >
                    admin_panel_settings
                  </span>
                </div>
                <h1 className="font-headline-lg text-headline-lg text-on-surface m-0 text-center">
                  تسجيل الدخول
                </h1>
                <p className="font-body-sm text-body-sm text-on-surface-variant text-center">
                  قم بتسجيل الدخول للوصول إلى لوحة التحكم
                </p>
              </div>
              {/* Form */}
              <form className="flex flex-col gap-5 w-full" id="loginForm">
                   {error && (
                  <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="bg-green-100 text-green-700 p-4 rounded-lg">
                    {success}
                  </div>
                )}
                {/* Username Input */}
                <div className="flex flex-col gap-1.5 relative">
                  <label
                    className="font-label-md text-label-md text-on-surface-variant mr-1"
                    htmlFor="username"
                  >
                    اسم المستخدم
                    {errUsername !== "" ? (
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {errUsername}
                      </span>
                    ) : (
                      ""
                    )}
                  </label>
                  <div className="relative flex items-center group">
                    <span className="material-symbols-outlined absolute right-4 text-outline group-focus-within:text-primary transition-colors">
                      person
                    </span>
                    <input
                      className="w-full bg-surface h-12 pr-12 pl-4 rounded-xl font-body-md text-on-surface placeholder:text-outline-variant focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-container-lowest transition-all"
                      id="username"
                      placeholder="أدخل اسم المستخدم"
                      type="text"
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                </div>

                {/* Password Input */}
                <div className="flex flex-col gap-1.5 relative">
                  <div className="flex justify-between items-end mr-1 ml-1">
                    <label
                      className="font-label-md text-label-md text-on-surface-variant"
                      htmlFor="password"
                    >
                      كلمة المرور
                      {errPass !== "" ? (
                        <span
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          {errPass}
                        </span>
                      ) : (
                        ""
                      )}
                    </label>
                    <a
                      className="font-label-sm text-label-sm text-vibrant-orange hover:text-primary transition-colors"
                      href="#"
                    >
                      نسيت كلمة المرور؟
                    </a>
                  </div>
                  <div className="relative flex items-center group">
                    <span className="material-symbols-outlined absolute right-4 text-outline group-focus-within:text-primary transition-colors">
                      lock
                    </span>
                    <input
                      className="w-full bg-surface h-12 pr-12 pl-12 rounded-xl font-body-md text-on-surface placeholder:text-outline-variant focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-container-lowest transition-all"
                      id="password"
                      placeholder="أدخل كلمة المرور"
                      type="password"
                      onChange={(e) => setPass(e.target.value)}
                    />

                    <button
                      className="absolute left-4 text-outline hover:text-on-surface transition-colors focus:outline-none flex items-center justify-center w-8 h-8 rounded-full hover:bg-surface-variant"
                      id="togglePassword"
                      type="button"
                    >
                      <span
                        className="material-symbols-outlined text-[20px]"
                        id="visibilityIcon"
                      >
                        visibility_off
                      </span>
                    </button>
                  </div>
                </div>
                {/* Verification Code Input */}
                
               
                {/* <Captcha
                  
                  onVerify={(success) => {
                 console.log(success);
                    if (success) {
                      setMsg("Verified");
                      setIsEnabled(true);
                    } else {
                      setMsg("Invalid code");
                      setIsEnabled(false);
                    }
                  }}
                /> */}
                {/* <div className="flex flex-col gap-1.5 relative">
                  <label
                    className="font-label-md text-label-md text-on-surface-variant mr-1"
                    htmlFor="captcha"
                  >
                    رمز التحقق
                    {errRechapta !== "" ? (
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {errRechapta}
                      </span>
                    ) : (
                      ""
                    )}
                  </label>
                  <div className="flex gap-3 h-12">
                    <div className="relative flex-1 flex items-center group">
                      <span className="material-symbols-outlined absolute right-4 text-outline group-focus-within:text-primary transition-colors">
                        verified_user
                      </span>
                      <input
                        className="w-full bg-surface h-full pr-12 pl-4 rounded-xl font-body-md text-on-surface placeholder:text-outline-variant focus:outline-none focus:ring-2 focus:ring-primary focus:bg-surface-container-lowest transition-all text-center tracking-widest"
                        id="captcha"
                        placeholder="----"
                        type="text"
                        onChange={(e) => setrechapteCode(e.target.value)}
                      />
                    </div> 
                    <div
                      className="w-24 h-full bg-surface-variant rounded-xl flex items-center justify-center cursor-pointer hover:bg-surface-dim transition-colors group relative overflow-hidden border border-vibrant-orange/20"
                      title="تحديث الرمز"
                    >
                      <div className="absolute inset-0 bg-gradient-to-br from-tertiary-fixed-dim/20 to-transparent" />
                      <span
                        className="font-headline-md text-headline-md text-on-surface-variant tracking-[0.2em] relative z-10 select-none text-vibrant-orange"
                        style={{ fontFamily: "monospace" }}
                      >
                        8B4X
                      </span>
                      <div className="absolute inset-0 flex items-center justify-center bg-surface-container-highest/80 opacity-0 group-hover:opacity-100 transition-opacity z-20 backdrop-blur-[2px]">
                        <span className="material-symbols-outlined text-on-surface">
                          refresh
                        </span>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* Submit Button */}
           

      {/* حقل CAPTCHA */}
       <Captcha setCaptchaVerified={setCaptchaVerified}/>
<button 
 className="w-full h-12 mt-4 rounded-xl bg-primary text-on-primary font-label-md text-label-md flex items-center justify-center gap-2"
  onClick={handleSubmitLogin}
>
  دخول
</button>
              </form>
            </div>
            {/* Security Badge */}
            <div className="mt-8 flex items-center gap-2 text-outline-variant">
              <span className="material-symbols-outlined text-sm">shield</span>
              <span className="font-label-sm text-label-sm">
                اتصال مشفر وآمن
              </span>
            </div>
          </div>
        </main>
      </>
    </>
  );
};
export default Login;
